import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { invokeGetService, invokePostService, setDashboardRefresh, setReRender, toggleRightDrawer } from "../../../store/global/actions";
import LoaderWithProgress from "../../atoms/loader/LoaderWithProgress.js"
import { getDetailsFromUrl } from '../../../services/blueprint'
import { getViews } from "../../../store/views/selectors";
import { editView } from "../../../store/views/actions";
import { getRightDrawerStatus } from '../../../store/global/selectors';
import { useHistory } from 'react-router-dom';
import { uiTypeChildren, mappingTransactionSchema, generateUpdatedMessageFields, sortFieldsByOrder } from '../../../config/fields';
import { findChildren } from '../../../services/entities/simulations.js';
import { findTriggerEvent, formatConstraintToDropdownValues } from '../../../utils/commonUtils.js';
import { Box, Grid } from '@material-ui/core';
import FieldExtensionTable from '../../atoms/FieldExtensionTable/index.js';
import UpdateCancel from '../../atoms/buttons/UpdateCancel.js';
import JsonTableEditor from '../../atoms/jsonFormEditor/JsonTableEditor.js';
import { clearFormErrors, findHelperText, injectInlineHelperText, showJsonEditorCustomValidationErrors, updateViewSchema } from '../../../utils/DashboardBuilder.js';
import SkeletonLoader from '../../atoms/loader/SkeletonLoader.js';

const shortUUiD = require("short-uuid");

const options = {
    form_name_root: "row_operation",
    show_errors: "interaction"
}

export default function TableRowActions({ onClose, noFloatButton, forceCancel, action, onCompletion, selectedSchema, index, selectedWidget }) {
    console.log("TableRowActions---------------------------", {selectedWidget})
    const dispatch = useDispatch();
    const history = useHistory();
    const editorWrapper = useRef()

    const selectedView = useSelector(getViews)
    const rightDrawerStatus = useSelector(getRightDrawerStatus);

    const { slug, blueprintId } = getDetailsFromUrl();
    const editorId = index ? `table_row_action_form_${index}` : "table_row_action_form";

    const [loading, setLoading] = useState(true)
    const [schemaValues, setSchemaValues] = useState({})
    const [isUpdating, setIsUpdating] = useState(false);
    const [allEvents, setAllEvents] = useState([])
    const [clusterlets, setClusterlets] = useState([])
    const [allFields, setFields] = useState([])
    const [formValues, setFormValues] = useState([])
    const [eventFields, setEventFields] = useState([])
    const [extendedFieldsData, setExtendedFieldsData] = useState([]);
    const [allMessages, setMessages] = useState([])
    const [transactions, setTransactions] = useState([]);
    const [getterTransaction, setGetterTransaction] = useState({});
    const [setterTransaction, setSetterTransaction] = useState({});
    const [fieldsHistory, setFieldsHistory] = useState(null)
    const [editorObj, setEditorObj] = useState(null);


    const isTableViewCopy = selectedWidget != undefined && selectedWidget?.type === 'table' && selectedWidget?.viewCopy === true ? true : false;

    useEffect(() => {
        loadClusterlets()
    }, [])


    const loadClusterlets = () => {
        dispatch(invokeGetService('getBlueprintConstructs', []))
            .then((response) => {
                setFields(response?.data?.fields)
                setMessages(response?.data?.messages)
                setSchemaValues(generateSchemaData(selectedSchema, response?.data?.transactions?.filter(tr => tr.type == 7), response?.data?.events, response.data.clusterlets, response?.data?.fields, response?.data?.messages));
                setClusterlets(response.data.clusterlets)
                setAllEvents(response?.data?.events)
                const filteredTransactins = response?.data?.transactions?.filter(tr => tr.type == 7);
                setTransactions(filteredTransactins ? filteredTransactins : []);
                let getterTransactionSchema = mappingTransactionSchema(response?.data?.transactions, false, [...response?.data?.clusterlets, ...response?.data?.clusterlets.filter(c => c.type === 1)], response?.data?.events, response?.data?.clusterlets.filter(c => c.type === 1), true, false, "Getter Transaction");
                let setterTransactionSchema = mappingTransactionSchema(response?.data?.transactions, false, [...response?.data?.clusterlets, ...response?.data?.clusterlets.filter(c => c.type === 1)], response?.data?.events, response?.data?.clusterlets.filter(c => c.type === 1), true, false, "Setter Transaction");

                setGetterTransaction(getterTransactionSchema)
                setSetterTransaction(setterTransactionSchema)
                setLoading(false)
            })
    }

    const generateSchemaData = (selectedSection, transactions, events, clusterlets, fields, messages) => {

        let schemaValues;
        if (selectedSection !== undefined && selectedSection !== null) {
            schemaValues = { ...selectedSection };

            schemaValues.pretransaction = selectedSection.pretransaction !== undefined ? { [selectedSection.pretransaction]: selectedSection.pretransaction } : { 'select': 'select' };
            schemaValues.pretransaction.instance = selectedSection.uniquevaluecolumnidentifier !== undefined ? selectedSection.uniquevaluecolumnidentifier : '';

            schemaValues.transaction = selectedSection.transaction !== undefined ? { [selectedSection.transaction]: selectedSection.transaction } : { 'select': 'select' };
            schemaValues.transaction.instance = selectedSection.instance !== undefined ? selectedSection.instance : '';

            if (selectedSection.extendedfields != undefined) {

                const transactionData = transactions?.find(txn => txn._id === selectedSection?.transaction);
                const triggerringEvent = findTriggerEvent({ transaction: transactionData, events, clusterlets });
                let eventMessage = messages?.find(msg => msg._id == triggerringEvent?.message)
                let messageChildren = findChildren(eventMessage, [], fields)

                const updatedMessageFields = generateUpdatedMessageFields(selectedSection.extendedfields, messageChildren.children)

                setEventFields(updatedMessageFields);
                setFieldsHistory({
                    [selectedSection.transaction]: updatedMessageFields
                })
            }
        }
        return schemaValues;
    }




    const commonProperties = {
        name: {
            title: 'Name',
            type: 'string',
            required: true,
            options: {
                layout: 'grid',
                grid_columns: 12
            },
        },
        title: {
            title: 'Label',
            type: 'string',
            required: true,
            options: {
                layout: 'grid',
                grid_columns: 12
            },
        },
        pretransaction: {
            title: 'Getter Transaction',
            type: 'string',
            enumSource: [{
                source: [{ title: 'Select', value: 'select' }, ...transactions.map((txn) => { return { 'title': txn.name, 'value': txn._id } })],
                title: '{{item.title}}',
                value: '{{item.value}}'
            }],
            options: {
                layout: 'grid',
                grid_columns: 6
            }
        },
        instance: {
            title: 'Getter Instance',
            type: 'string',
            options: {
                layout: 'grid',
                grid_columns: 6
            },
        },
        transaction: {
            title: 'Setter Transaction',
            type: 'string',
            enumSource: [{
                source: [{ title: 'Select', value: 'select' }, ...transactions.map((txn) => { return { 'title': txn.name, 'value': txn._id } })],
                title: '{{item.title}}',
                value: '{{item.value}}'
            }],
            options: {
                layout: 'grid',
                grid_columns: 6
            }
        },
        uniquevaluecolumnidentifier: {
            title: 'Setter Instance',
            type: 'string',
            options: {
                layout: 'grid',
                grid_columns: 6
            },
        },

    };

    const schema = {
        type: 'object',
        required: [],
        options: {
            layout: 'grid',
            disable_properties: 'false'
        },
        properties: { name: commonProperties.name, title: commonProperties.title, pretransaction: getterTransaction.transaction, transaction: setterTransaction.transaction }

    }

    const onChangeJsonEditor = (values, jsonEditor) => {
        setFormValues(values);
        setEditorObj(jsonEditor);
        if (values != undefined && values?.transaction != undefined && values?.transaction.select == undefined) {
            const keys = Object.keys(values?.transaction);
            const transactionData = transactions?.find(txn => txn._id === keys[0]);
            const triggerringEvent = findTriggerEvent({ transaction: transactionData, events: allEvents, clusterlets });

            if (fieldsHistory != null && fieldsHistory[transactionData?._id]) setEventFields(fieldsHistory[transactionData?._id])
            else setEventFields(triggerringEvent ? formatFileds(triggerringEvent._id) : []);
        }
        else {
            setEventFields([]);
        }

        const getterElement = "getter";
        const getterHelperText = findHelperText("table_row_operation", getterElement)
        injectInlineHelperText({
            formId: editorId,
            schemaPath: "row_operation.pretransaction",
            helperText: getterHelperText
        })


        const setterElement = "setter";
        const setterHelperText = findHelperText("table_row_operation", setterElement)
        injectInlineHelperText({
            formId: editorId,
            schemaPath: "row_operation.transaction",
            helperText: setterHelperText
        })
    }


    const getFormattedMessageFields = (messageFields=[]) => {
        const sortedFields = sortFieldsByOrder(messageFields || [])

        function generateNested(data) {
            return data.map(item => {
                let newObj = {
                    id: item._id,
                    name: item.name,
                    type: item.attributes.type,
                    optional: item?.attributes?.optional,
                    desc: item.attributes.desc ? item.attributes.desc : '',
                    children: []
                };

                if (item?.attributes?.default && item?.attributes?.default != "") {
                    newObj.default = item.attributes.default;
                }

                if (item?.attributes?.constraint && item?.attributes?.constraint != "") {
                    newObj.constraint = formatConstraintToDropdownValues(item.attributes.constraint);
                    newObj.defaultConstraint = newObj.constraint;
                }

                if (item.children) {
                    newObj.children = generateNested(item.children.map(child => ({ ...child })));
                }

                return newObj;
            });
        }

        let eventFields = generateNested(sortedFields);
        return eventFields;
    }

    const formatFileds = (eventId, idRequired) => {
        let selectedEvent = allEvents.find(ev => ev._id == eventId)
        let eventMessage = allMessages.find(msg => msg._id == selectedEvent.message)


        if (selectedEvent == undefined) {
            return []
        }
        const fields = JSON.parse(JSON.stringify(allFields));
        let newData = findChildren(eventMessage, [], fields, allMessages)
        let formattedEventFileds = getFormattedMessageFields(newData.children)

        return formattedEventFileds

    }

    const generateTransactionObject = (transaction) => {
        let transactionObj = {}
        const keys = Object.keys(transaction);
        transactionObj["transaction"] = keys[0]
        if (transaction.instance != undefined) transactionObj["instance"] = transaction.instance;

        return transactionObj

    }

    const onUpdate = () => {
        clearFormErrors();
        const editorValidationErrors = editorObj.validate();
        const customValidationErrors = customValidation()
        showJsonEditorCustomValidationErrors(customValidationErrors)
        if ([...editorValidationErrors, ...customValidationErrors].length > 0) {
            editorObj.showValidationErrors(editorValidationErrors);
            return;
        }
        const { name, title, pretransaction, transaction, instance, uniquevaluecolumnidentifier } = formValues;
        setIsUpdating(true)
        let extended_fields = extendedFieldsData?.length > 0 ? extendedFieldsData : eventFields;
        extended_fields = extended_fields.map(field => {
            const { defaultConstraint, ...rest } = field; 
            return rest;
        });
        let selectedItem = { ...selectedWidget }
        if (selectedWidget?.type === 'control-button') {
            if (transaction !== undefined && transaction !== 'select') {
                selectedItem.transaction = transaction;
            }

        } else if (selectedWidget?.type === 'table') {

            let dropDownChild = selectedItem.children.find(field => field.type === 'drop-down')

            if (dropDownChild === undefined) {

                let uiTypeChildrenObj = uiTypeChildren();
                uiTypeChildrenObj['table'] ? selectedItem.children = [...selectedItem.children, ...uiTypeChildrenObj['table']] : selectedItem.children = selectedItem.children;
            }


            let rowActionObj = {
                name: name,
                desc: title,
                type: "button",
                title: title,
                action: 'create',
                children: [],
            }

            if (transaction.select == undefined) {
                let transactionObject = generateTransactionObject(transaction)

                rowActionObj.transaction = transactionObject.transaction
                rowActionObj.instance = transactionObject.instance
            }

            if (pretransaction.select == undefined) {
                let preTransactionObject = generateTransactionObject(pretransaction)
                rowActionObj.pretransaction = preTransactionObject.transaction
                rowActionObj.action = 'edit'
                rowActionObj.uniquevaluecolumnidentifier = preTransactionObject.instance

            }


            if (extended_fields.length > 0) {
                rowActionObj.extendedfields = extended_fields;
            }



            if (selectedSchema == undefined) {
                rowActionObj.id = shortUUiD.generate();

                const index = selectedItem.children.findIndex(item => item.type === "drop-down");

                if (index != -1) {
                    selectedItem.children[index].children.push(rowActionObj)
                }
            }

            else {
                rowActionObj.id = selectedSchema?.id;

                const index = selectedWidget.children.findIndex(item => item.type === "drop-down");

                const existingIndex = selectedWidget.children[index].children.findIndex(item => item.id == selectedSchema?.id);
                if (existingIndex !== -1) {
                    selectedWidget.children[index].children[existingIndex] = rowActionObj;
                }

            }


        }

        dispatch(setDashboardRefresh({ type: "widget", action: "edit", entity:{id: selectedWidget.id, ... selectedItem} }));
        const updatedView = updateViewSchema(selectedView, 'edit', { id: selectedItem.id, updatedData: selectedItem });
        handleViewUpdate(updatedView);
    }

    const handleViewUpdate = (updatedView) => {
        dispatch(invokePostService('updateView', { view: updatedView }, [selectedView._id])).then(response => {
            setIsUpdating(false);
            if (response.status === true) {
                dispatch(editView(updatedView));
                onCompletion('Widget', action === 'create' ? 'add' : 'edit');
                // if (isTableViewCopy) {
                //     dispatch(toggleRightDrawer());
                // }
            } else {
                if (response.code === 255) {
                    history.push(`/blueprint/${slug}/${blueprintId}/system-model`);
                    dispatch(setReRender());
                    if (rightDrawerStatus === true) dispatch(toggleRightDrawer());
                }
            }
        })
    }


    const validation = (schema, value, path) => {

        let errors = [];
        const whiteSpacePattern = /^[a-zA-Z0-9_]*$/;
        if (path === "row_operation.name" && value === "") {
            errors.push({
                path: "row_operation.name",
                property: 'format',
                message: "Please enter name"
            })
        }
        if (path === "row_operation.name" && !whiteSpacePattern.test(value)) {
            errors.push({
                path: "row_operation.name",
                property: 'format',
                message: "This field cannot contain special characters or white spaces"
            })
        }
        if (path === "row_operation.title" && value === "") {
            errors.push({
                path: "row_operation.title",
                property: 'format',
                message: "Please enter label"
            })
        }

        return errors;
    }

    const customValidation = (data) => {
        let errors = [];
        if (formValues.transaction.select) {
            errors.push({
                path: "row_operation.transaction",
                property: 'format',
                message: "Please select setter transaction",
                isSwitcher: true
            })
        }
        return errors;
    }


    useEffect(() => {
        if (editorWrapper?.current) {
            const grid1 = editorWrapper?.current?.querySelector('.MuiGrid-spacing-xs-1');
            const grid2 = editorWrapper?.current?.parentNode


            if (grid1) grid1.style.margin = 0;
            if (grid2) grid2.style.margin = 0;
        }
    }, [editorWrapper.current])


    return (

        <>
            {loading && <SkeletonLoader isLabelled type='form' rows={4} />}
            {!loading && <Box style={{ width: '100%' }} ref={editorWrapper}>
                <JsonTableEditor options={options} schema={schema} schemaValues={schemaValues} onChangeJsonEditor={onChangeJsonEditor} editorId={editorId} validation={validation} />
                <Grid item xs={12} style={{ marginBottom: '10px', overflow: 'hidden' }}>
                    <FieldExtensionTable onLoadData={eventFields || []} setExtendedFieldsData={setExtendedFieldsData} />
                </Grid>
            </Box>}
            <Grid item xs={12} style={loading ? { display: "flex", justifyContent: "flex-end", marginTop: '30vh' } : { display: "flex", justifyContent: "flex-end" }}>
                <UpdateCancel updateDisable={isUpdating || loading} noFloatButton={noFloatButton} forceCancel={forceCancel} content={isUpdating ? "Updating.." : "Update"} onUpdate={onUpdate} onCancel={onClose} />
            </Grid>
        </>



    )

}